module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.5e3bc5e7.png";